export default __webpack_public_path__ + "static/media/live10.a1151343.jpeg";